import { Navigate } from "react-router-dom";
import { useMe } from "../hooks/useMe";
import { useAppStore } from "../state/useAppStore";

/** `/app` — one link to share. Lands in the person's workspace thread. */
export function AppEntry() {
  const { data: me, isLoading, error } = useMe();
  const last = useAppStore((s) => s.activeWorkspaceId);
  if (error) return <Navigate to="/login?next=/app" replace />;
  if (isLoading || !me) return null;
  const target = me.memberships.find((m) => m.workspaceId === last) ?? me.memberships[0];
  if (!target) return <Navigate to="/post-login" replace />;
  return <Navigate to={`/app/${target.workspaceId}/thread`} replace />;
}
